module.exports = __webpack_public_path__ + "img/mobile_login.6a05c9f.png";